import { C } from '../palette';
import { PixelBuf } from '../pixel';

/** Sunbit (collectible currency), 4 spin frames, 10x14. */
export function sunbitSprite(frame: number): PixelBuf {
  const p = new PixelBuf(10, 14);
  const widths = [8, 5, 2, 5];
  const w = widths[frame % 4];
  const x = 5 - Math.ceil(w / 2);
  p.blob(x, 1, w, 12, C.coinDark);
  p.blob(x + 1, 2, Math.max(1, w - 2), 10, C.coin);
  if (w >= 5) {
    p.rect(x + 2, 4, 1, 6, C.coinLight);
    p.rect(x + w - 3, 5, 1, 4, C.coinDark);
  }
  return p;
}

/** Sunberry — the grow power-up, 14x14. */
export function sunberrySprite(): PixelBuf {
  const p = new PixelBuf(14, 14);
  p.blob(1, 3, 12, 11, C.outline);
  p.blob(2, 4, 10, 9, C.berry);
  p.rect(3, 5, 4, 2, C.berryLight);
  p.rect(4, 10, 6, 2, C.berryDark);
  p.px(9, 6, C.white);
  // leaf + stem
  p.rect(6, 1, 2, 3, C.stemDark);
  p.rect(8, 1, 4, 2, C.leaf);
  p.rect(2, 2, 4, 2, C.leaf);
  return p;
}

/** Ember Seed — grants the energy orb attack, 14x14. */
export function emberSeedSprite(frame: number): PixelBuf {
  const p = new PixelBuf(14, 14);
  p.blob(2, 2, 10, 11, C.outline);
  p.blob(3, 3, 8, 9, C.emberDark);
  p.blob(4, 5, 6, 7, C.ember);
  p.rect(5, 7, 4, 4, C.emberLight);
  if (frame % 2 === 0) {
    p.rect(6, 1, 2, 2, C.emberLight);
    p.px(5, 2, C.ember);
  } else {
    p.rect(5, 1, 2, 2, C.ember);
    p.px(8, 1, C.emberLight);
  }
  p.rect(6, 11, 2, 1, C.white);
  return p;
}

/** Prism Shard — brief invincibility, 14x14, 2 twinkle frames. */
export function prismSprite(frame: number): PixelBuf {
  const p = new PixelBuf(14, 14);
  const body = frame % 2 === 0 ? C.prism : C.prismLight;
  // diamond
  for (let i = 0; i < 6; i++) {
    p.rect(6 - i, 1 + i, 2 + i * 2, 1, C.outline);
  }
  for (let i = 0; i < 6; i++) {
    p.rect(6 - i, 12 - i, 2 + i * 2, 1, C.outline);
  }
  for (let i = 1; i < 5; i++) {
    p.rect(7 - i, 2 + i, i * 2, 1, body);
    p.rect(7 - i, 11 - i, i * 2, 1, i > 2 ? C.prismDark : body);
  }
  p.rect(5, 6, 4, 2, C.white);
  return p;
}

/** Heart Pod — extra life, 14x14. */
export function heartPodSprite(): PixelBuf {
  const p = new PixelBuf(14, 14);
  p.blob(1, 3, 12, 11, C.outline);
  p.blob(2, 4, 10, 9, C.pod);
  p.rect(3, 10, 8, 2, C.podDark);
  // heart
  p.rect(4, 6, 2, 2, C.white);
  p.rect(8, 6, 2, 2, C.white);
  p.rect(4, 7, 6, 2, C.white);
  p.rect(5, 9, 4, 1, C.white);
  p.rect(6, 10, 2, 1, C.white);
  // stem
  p.rect(6, 1, 2, 3, C.stemDark);
  p.rect(8, 1, 3, 2, C.leaf);
  return p;
}

/** Energy orb projectile, 8x8, 4 frames. */
export function orbSprite(frame: number): PixelBuf {
  const p = new PixelBuf(8, 8);
  p.blob(1, 1, 6, 6, C.emberDark);
  p.blob(2, 2, 4, 4, C.ember);
  const spots: [number, number][][] = [
    [
      [2, 2],
      [4, 4],
    ],
    [
      [4, 2],
      [2, 4],
    ],
    [
      [3, 1],
      [3, 5],
    ],
    [
      [1, 3],
      [5, 3],
    ],
  ];
  for (const [x, y] of spots[frame % 4]) p.rect(x, y, 2, 2, C.emberLight);
  return p;
}

/** Goal banner, 14x12. */
export function bannerSprite(): PixelBuf {
  const p = new PixelBuf(14, 12);
  p.rect(0, 0, 14, 12, C.outline);
  p.rect(1, 1, 12, 10, C.gold);
  p.rect(2, 2, 10, 3, C.coinLight);
  // sprout emblem
  p.rect(6, 4, 2, 5, C.leafDark);
  p.rect(3, 5, 3, 2, C.leaf);
  p.rect(8, 6, 3, 2, C.leaf);
  return p;
}

/** Checkpoint pennant, 10x10. */
export function pennantSprite(lit: boolean): PixelBuf {
  const p = new PixelBuf(10, 10);
  p.rect(0, 0, 10, 10, C.outline);
  p.rect(1, 1, 8, 8, lit ? C.pod : C.stoneDark);
  p.rect(2, 2, 6, 2, lit ? C.white : C.stone);
  p.rect(3, 5, 4, 2, lit ? C.white : C.stone);
  return p;
}
